import {useEffect,useState} from 'react';

export default function useHeaderHeight() {
  const [headerHeight, setHeaderHeight] = useState(0)
  
  useEffect(() => {
    const headerEl = document.getElementById('header');
    if(document && headerEl && headerEl.offsetHeight) {
      setHeaderHeight(headerEl.offsetHeight)
      new ResizeObserver(entries => {
        setHeaderHeight(headerEl.offsetHeight)
      }).observe(headerEl);
    }
  },[setHeaderHeight])

  return [headerHeight];
}
